import { composeError } from "dataProvider";
import { get } from "lodash";
import { DataProvider } from "react-admin";

export const requestPresignedUrl = async (provider: DataProvider) => {
  try {
    const presignedUrlData: { data: IPresignedUrlPdfDocument } =
      await provider.customCreate("presignedUrl/schoolCcaDocument", {
        data: {},
      });

    return presignedUrlData.data;
  } catch (error) {
    const body = get(error, "body", {});
    const msg = composeError(body);
    return Promise.reject({ message: `Error get presigned url: ${msg}` });
  }
};

export const isValidUrl = (url: string): boolean => {
  try {
    new URL(url);
    return true;
  } catch (error) {
    return false;
  }
};
